import { render, staticRenderFns } from "./Study2.vue?vue&type=template&id=75455b6e&scoped=true&"
import script from "./Study2.vue?vue&type=script&lang=js&"
export * from "./Study2.vue?vue&type=script&lang=js&"
import style0 from "./Study2.vue?vue&type=style&index=0&id=75455b6e&prod&lang=scss&scoped=true&"
import style1 from "./Study2.vue?vue&type=style&index=1&id=75455b6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75455b6e",
  null
  
)

export default component.exports